import { Add, Analytics, AssignmentReturn, AutoMode, BarChartOutlined, Bloodtype, Business, Campaign, CampaignOutlined, ChatRounded, CheckCircle, Contacts, Dashboard, Diversity1, Diversity2, Engineering, EventAvailable, EventSeat, Folder, Key, Leaderboard, List, LocalPolice, Map, MapOutlined, MapRounded, Message, Money, PaymentOutlined, Pending, PendingActions, People, Person2, School, Settings, SupportAgentOutlined, VideoCameraBack, VideoLabel, VolunteerActivism } from "@mui/icons-material"

import { Navigate } from "react-router-dom"
import AppContainer from "./components/layouts/common/AppContainer"

import SignInController from "./pages/signin/SignInController"
import UserListController from "./pages/user/ListController"
import DocumentsListController from "./pages/documents/ListController"

import { USER_ROLES } from "./utils/constants"
import PagenotFound from "./components/layouts/PagenotFound"
import ListController from "./pages/secrets/ListController"
import MODULES from "./utils/module.constant"
import NotAllowedComponent from "./components/layouts/NotAllowedComponent"
import { getDefaultRedirect } from "./utils/routinghelper"
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import ProductListController from "./pages/products/ListController";
import RegionListController from "./pages/region/ListController";
import CampListController from "./pages/camp/ListController"
import BeneficiaryCreateController from "./pages/beneficiary/CreateController"
import BeneficiaryListController from "./pages/beneficiary/ListController"
import ListControllerBeneficiary from "./pages/Beneficiary-modal/ListController";
import CreateControllerBeneficiary from "./pages/Beneficiary-modal/CreateController";
import BeneficiaryAudioGramController from "./pages/beneficiary/AudioGram/BeneficiaryAudioGramController"
import AudiogramReport from "./pages/beneficiary/AudioGram/AudiogramReport"
import DashboardController from "./pages/dashboard/DashboardListController"

const loggedInPathElementRender = (login, allowed = [], permittedModule = [], Component, defaultRedirect, hideInPannel = false) => {

  const obj = {
    hideInPannel,
    element: Component,
  }
  if (!login) {
    obj['element'] = <Navigate replace to={'/sign-in'} />
  } else {

    let found = false
    for (let module of allowed) {
      for (let allowedModule of permittedModule) {
        if (module == allowedModule) {
          found = true
          break;
        }
      }
    }
    if (!found) {
      obj['hideInPannel'] = true
      obj['element'] = <NotAllowedComponent />
    }
  }
  return obj
}

const defineRoutes = (user) => {
  const allowedModules = user.data.modules ?? []
  const defaultRedirect = getDefaultRedirect(allowedModules, user.data.role)
  return [
    {
      path: "sign-in",
      element: !user.isLoggedIn ? (
        <SignInController />
      ) : (
        <Navigate replace to={defaultRedirect} />
      ),
      hideInPannel: true,
    },
    {
      path: "",
      element: user.isLoggedIn ? (
        <Navigate replace to={defaultRedirect} />
      ) : (
        <Navigate replace to="/sign-in" />
      ),
      hideInPannel: true,
    },
    {
      path: "dashboard",
      icon: <Dashboard />,
      title: "Dashboard",
      ...loggedInPathElementRender(
        user.isLoggedIn,
        [MODULES.DASHBOARD],
        allowedModules,
        <AppContainer>
          <DashboardController />
        </AppContainer>,
        defaultRedirect,
      ),
    },

    {
      path: "beneficiary",
      icon: <Diversity1 />,
      title: "Beneficiary",
      ...loggedInPathElementRender(
        user.isLoggedIn,
        [MODULES.BENEFICIARY_FETCH],
        allowedModules,
        <AppContainer />,
        defaultRedirect,
      ),

      children: [
        {
          path: "add",
          icon: Add,
          title: "Add Beneficiary",
          // element: user.isLoggedIn ? <BeneficiaryCreateController /> : <Navigate replace to="/sign-in" />,
          ...loggedInPathElementRender(
            user.isLoggedIn,
            [MODULES.BENEFICIARY_ADD],
            allowedModules,
            <CreateControllerBeneficiary />,
            defaultRedirect,
          ),
        },
        {
          path: "beneficiary-data",
          icon: BarChartOutlined,
          title: "Beneficiary Data",
          // element: user.isLoggedIn ? <BeneficiaryCreateController /> : <Navigate replace to="/sign-in" />,
          ...loggedInPathElementRender(
            user.isLoggedIn,
            [MODULES.BENEFICIARY_FETCH],
            allowedModules,
            <ListControllerBeneficiary />,
            defaultRedirect,
          ),
        },
        {
          path: ":id",
          title: "Beneficiary View",
          icon: Key,

          element: <BeneficiaryAudioGramController />,
          hideInPannel: true,
        },
        {
          path: ":id/audiogram-pdf",
          title: "Audiogram Report",
          icon: Key,
          element: <AudiogramReport />,
          hideInPannel: true,
        },
      ],
    },
    {
      path: "camp",
      icon: <Campaign />,
      title: "Camp",
      ...loggedInPathElementRender(
        user.isLoggedIn,
        [MODULES.CAMPS],
        allowedModules,
        <AppContainer>
          <CampListController />
        </AppContainer>,
        defaultRedirect,
      ),
    },
    {
      path: "users",
      icon: <People />,
      title: "Users",
      ...loggedInPathElementRender(
        user.isLoggedIn,
        [MODULES.USER_MODULE],
        allowedModules,
        <AppContainer>
          <UserListController />
        </AppContainer>,
        defaultRedirect,
      ),
    },

    // {
    //   path: "products",
    //   icon: <ProductionQuantityLimitsIcon />,
    //   title: "Products",
    //   ...loggedInPathElementRender(
    //     user.isLoggedIn,
    //     [MODULES.PRODUCT_MODULE],
    //     allowedModules,
    //     <AppContainer>
    //       <ProductListController />
    //     </AppContainer>,
    //     defaultRedirect,
    //   ),
    // },
    // {
    //     path: "region",
    //     icon: <Map />,
    //     title: "Region",
    //     ...loggedInPathElementRender(user.isLoggedIn, [MODULES.REGION_MODULE], allowedModules, <AppContainer ><RegionListController /></AppContainer>, defaultRedirect)
    // },

    // {
    //     path: "admin",
    //     icon: <Settings />,
    //     title: "Admin Area",
    //     // hideInPannel: user.data.role != USER_ROLES.ADMIN,
    //     // element: user.isLoggedIn ? <AppContainer /> : <Navigate replace to="/sign-in" />,
    //     ...loggedInPathElementRender(user.isLoggedIn,allowedModules, <AppContainer />, defaultRedirect),

    //     children: [

    //         {
    //             path: "secrets",
    //             title: "Secrets Management",
    //             icon: Key,

    //             element: <ListController />
    //         },
    //         {
    //             path: "docs",
    //             title: "Docs",
    //             icon: Folder,

    //             element: <DocumentsListController />
    //         }
    //     ],
    // },

    {
      path: "*",
      hideInPannel: true,
      element: !user.isLoggedIn ? (
        <Navigate replace to={"/sign-in"} />
      ) : (
        <PagenotFound />
      ),
    },
  ];
}
export default defineRoutes


/* 

================================================================
Demo Object
================================================================
        {
            path: "sign-in",
            element: !user.isLoggedIn ? <SignInController /> : <Navigate replace to="/leaves" />,
            
            title: "Leave Management", // it will use as name in side navbar
            component:<></>


             children: [
                {
                    path: "",
                    title: "My Leaves",// it will use as name in side navbar
                    element: <MyLeaveController />,
                    
                }
            ],
        },




================================================================
================================================================


*/